import { styled } from "@/stitches/config"
import { multipleSelectors } from "@/stitches/utils"

export const STabListItem = styled("button", {
  reset: true,
  paddingTop: "$20",
  paddingBottom: "$8",
  color: "$theme-n6-n5",
  position: "relative",
  cursor: "pointer",
  outline: "none",

  "@sm": {
    paddingTop: 0,
    paddingBottom: "$12",
  },

  "&:not(:last-of-type)": {
    marginRight: "$24",

    "@sm": {
      marginRight: "$48",
    },
  },

  "&[aria-selected='true']": {
    color: "$system-black",

    "& > p": {
      textShadow: "0 0 .75px var(--colors-system-black)",
    },

    after: {
      transform: "scaleX(1)",
    },

    hover: {
      color: "$system-black",

      "& > p": {
        textShadow: "0 0 .75px var(--colors-system-black)",
      },

      after: {
        backgroundColor: "$system-black",
      },
    },

    keyboardFocus: {
      color: "$system-black",

      "& > p": {
        textShadow: "0 0 .75px var(--colors-system-black)",
      },

      after: {
        backgroundColor: "$system-black",
        transform: "scaleX(1)",
        opacity: 0.5,
      },
    },

    active: {
      color: "$system-black",

      "& > p": {
        textShadow: "0 0 .75px var(--colors-system-black)",
      },

      after: {
        backgroundColor: "$system-black",
      },
    },
  },

  ...multipleSelectors(["hover", "active"], {
    color: "$neutrals-7",

    "& > p": {
      textShadow: "0 0 .75px var(--colors-neutrals-7)",
    },
  }),

  keyboardFocus: {
    color: "$neutrals-7",

    "& > p": {
      textShadow: "0 0 .75px var(--colors-neutrals-7)",
    },

    after: {
      backgroundColor: "$neutrals-7",
      transform: "scaleX(1)",
      opacity: 0.5,
    },
  },

  after: {
    backgroundColor: "$system-black",
    borderRadius: "$8",
    content: "''",
    bottom: -1,
    height: "$2",
    left: 0,
    right: 0,
    position: "absolute",
    transformOrigin: "left center",
    transform: "scaleX(0)",
    transition: "100ms transform ease-out",
  },
})
